const _ = require('lodash');
const EnvReportInterface = require('relevant-shared/reportData/envReportInterface');
const TypeCustomizer = require('./typeCustomizer');

class ProgrammaticCustomizer extends TypeCustomizer {
	getInitSums({ isAdministrator }) {
		const options = EnvReportInterface.getGenericData().userReportOptions.programmatic.USER_SUM_OPTIONS;
		if (isAdministrator) {
			return ['revenueAfterSsp'];
		} if (options.includes('publisherRevenue')) {
			return ['publisherRevenue'];
		} if (options.includes('revenueAfterSsp')) {
			return ['revenueAfterSsp'];
		}
		return [options[0]];
	}

	getGroupByOptions({ GROUP_BY_OPTIONS }, { placementLabels, hasAdvertiserDomain, hasAdvertisingCategory }, { groupBy, whereIn }) {
		// Don't display placement label option if there are no labels
		// (Might be one 'Unlabelled' label, but interpret as empty)
		const hasLabels = placementLabels && Object.keys(placementLabels).length > 1;
		// In case we saved a report and then removed all ssps with advertiser domains or advertising categories
		const hasOrHadAdvertiserDomain = hasAdvertiserDomain || groupBy?.includes('advDomainNr') || whereIn?.advDomainNr;
		const hasOrHadAdvertisingCategory = hasAdvertisingCategory || groupBy?.includes('advCategoryId') || whereIn?.advCategoryId;
		const omits = _.filter([
			!hasLabels && 'placementLabel',
			!hasOrHadAdvertiserDomain && 'advDomainNr',
			!hasOrHadAdvertisingCategory && 'advCategoryId',
		]);
		return _.omit(GROUP_BY_OPTIONS, omits);
	}
}

module.exports = ProgrammaticCustomizer;
